import { SvgIcon } from "@mui/material";
import { CSSProperties } from "react";

const FastAddIcon = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#1062D0";
  if (color) c = color;
  return (
    <svg
      style={{ transform: `scale(${scale || 1})` }}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.51158 22C6.43381 22 6.35502 21.9845 6.27978 21.952C6.01647 21.8384 5.87404 21.551 5.94318 21.2727L7.92458 13.297H2.58593C2.39269 13.297 2.21187 13.2018 2.10262 13.0423C1.99336 12.8829 1.96977 12.6799 2.03945 12.4997L5.95592 2.37457C6.04322 2.14883 6.26033 2 6.5024 2H11.8915C12.0895 2 12.2741 2.1 12.3823 2.26586C12.4905 2.43172 12.5076 2.64097 12.4277 2.82218L10.1086 8.08623H14.6953C14.9096 8.08623 15.1068 8.20322 15.2095 8.39127C15.3122 8.57931 15.3041 8.80845 15.1883 8.98876L7.00486 21.7306C6.8942 21.903 6.70603 22 6.51158 22V22ZM3.44081 12.1252H8.67391C8.85419 12.1252 9.02446 12.2082 9.13548 12.3502C9.24653 12.4922 9.28602 12.6774 9.24254 12.8524L7.93575 18.1127L13.6226 9.25806H9.21016C9.01215 9.25806 8.82755 9.15806 8.71934 8.9922C8.61118 8.82634 8.59411 8.61708 8.67395 8.43591L10.9931 3.17187H6.904L3.44081 12.1252Z"
        fill={c}
      />
      <path d="M14 17.001H22" stroke={c} strokeWidth="1.4" stroke-linecap="round" />
      <path d="M18 13V21" stroke={c} strokeWidth="1.4" stroke-linecap="round" />
    </svg>
  );
};

export default FastAddIcon;
